module.exports = __webpack_public_path__ + "img/Emotions.e5631ff3.svg";